// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"563":"98e40d5546446596","708":"2f9bfdc3e8208798","907":"d120c979eef99a98","960":"584621bb3654b44c"}[chunkId] + ".js";
};